import { useTranslation } from 'react-i18next';

// @taskId T850 — versión/commit del bundle, trazabilidad de despliegue (H5)
export function VersionFooter() {
  const { t } = useTranslation(['common']);
  const version = __APP_VERSION__ || t('common:version.dev');
  const commit = __APP_COMMIT__;

  return (
    <footer className="px-8 py-2 text-[10px] text-muted-foreground/70 border-t border-border">
      {t('common:version.label')}: {version}
      {commit && ` · ${t('common:version.commit')} ${commit.slice(0, 7)}`}
    </footer>
  );
}
